
// CepField.js

import React, { useState, useEffect } from 'react';

function CepField({ value, onChange, onAddressChange }) {
  const [address, setAddress] = useState({
    logradouro: '',
    bairro: '',
    cidade: '',
    uf: '',
  });

  useEffect(() => {
    if (value && value.length === 8) {
      fetch(`https://viacep.com.br/ws/${value}/json/`)
        .then((response) => response.json())
        .then((data) => {
          const newAddress = {
            logradouro: data.logradouro || '',
            bairro: data.bairro || '',
            cidade: data.localidade || '',
            uf: data.uf || '',
          };
          setAddress(newAddress);
          if (onAddressChange) {
            onAddressChange(newAddress);
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar o endereço:', error);
        });
    }
  }, [value, onAddressChange]);

  const handleChange = (e) => {
    const newValue = e.target.value.replace(/\D/g, '');
    onChange(newValue);
  };

  const handleAddressChange = (field, value) => {
    const newAddress = { ...address, [field]: value };
    setAddress(newAddress);
    if (onAddressChange) {
      onAddressChange(newAddress);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', marginBottom: '0px', alignItems: 'center' }}>
        <div style={{ marginRight: '20px' }}>
          <label style={{ display: 'block', width: '0px', marginBottom: '0px',marginTop: '0px' }}>CEP:</label>
          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="Digite o CEP"
            maxLength={8}
            style={{ width: '120px', height: '30px' }}
          />
        </div>

        <div style={{ marginRight: '20px' }}>
          <label style={{ display: 'block', marginBottom: '0px' }}>Logradouro:</label>
          <input
            type="text"
            value={address.logradouro}
            onChange={(e) => handleAddressChange('logradouro', e.target.value)}
            style={{ width: '420px', height: '30px' }}
          />
        </div>
      </div>

      <div style={{ display: 'flex', marginBottom: '0px', marginTop: '0px'  }}>
        <div style={{ marginRight: '20px' }}>
          <label style={{ display: 'block', marginBottom: '0px' }}>Bairro:</label>
          <input
            type="text"
            value={address.bairro}
            onChange={(e) => handleAddressChange('bairro', e.target.value)}
            style={{ width: '420px', height: '30px' }}
          />
        </div>

        <div style={{ marginRight: '20px' }}>
          <label style={{ display: 'block', marginBottom: '0px' }}>Cidade:</label>
          <input
            type="text"
            value={address.cidade}
            onChange={(e) => handleAddressChange('cidade', e.target.value)}
            style={{ width: '340px', height: '30px' }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '0px' }}>Estado:</label>
          <input
            type="text"
            value={address.uf}
            onChange={(e) => handleAddressChange('uf', e.target.value)}
            style={{ width: '60px', height: '30px' }}
          />
        </div>

      </div>
    </div>
  );
}

export default CepField;